import React from 'react'
import ImgixImg from './index'

import { path } from '@uswitch/ev-utils/obj'
import { useEntity } from '@uswitch/ev-utils/context/selectors'

export const ProviderImage = ({ entity, ...props }) => {
  const { name, image } = useEntity(entity)
  return <ImgixImg {...props} alt={name} src={image} />
}

const ImgixImgConnected = ({ entity, ...props }) => {
  const { description, file, ...imageProps } = useEntity(entity)
  const aspectRatio = file?.details && file.details.image.height / file.details.image.width
  const width = props.width
  const height = props.height || (width && aspectRatio && width * aspectRatio)

  return (
    <ImgixImg
      {...props}
      {...imageProps}
      alt={description || imageProps.title}
      src={path(['url'], file)}
      width={width}
      height={height}
      sx={{ height: 'auto' }}
      aspectRatio={aspectRatio}
    />
  )
}

export default ImgixImgConnected
